var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGovern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.883 5.184l6.75-2.071a1.25 1.25 0 01.734 0l6.75 2.07c.525.162.883.647.883 1.196V12c0 5.706-6.08 8.303-7.64 8.876a1.04 1.04 0 01-.72 0C10.08 20.303 4 17.706 4 12V6.38c0-.55.358-1.034.883-1.195z",
    fill: "#ADC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.894 3.007A1.25 1.25 0 001 4.205V12c0 7.799 8.784 11.242 10.653 11.886.23.08.465.08.694 0C14.217 23.242 23 19.8 23 12V4.205a1.25 1.25 0 00-.894-1.198l-9.75-2.9a1.25 1.25 0 00-.713 0l-9.75 2.9zm.356 1.198V12c0 3.371 1.884 5.858 4.15 7.645 2.22 1.75 4.672 2.714 5.6 3.039.928-.325 3.38-1.288 5.6-3.04 2.266-1.786 4.15-4.273 4.15-7.644V4.205L12 1.305l-9.75 2.9z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.367 3.113a1.25 1.25 0 00-.734 0l-6.75 2.07A1.25 1.25 0 004 6.38V12c0 5.706 6.08 8.303 7.64 8.875.234.087.486.087.72 0C13.92 20.303 20 17.706 20 12V6.379a1.25 1.25 0 00-.883-1.195l-6.75-2.071zM12 4.308l-6.75 2.07V12c0 2.355 1.24 4.11 2.787 5.404 1.508 1.262 3.205 1.988 3.963 2.272.758-.284 2.455-1.01 3.963-2.272 1.547-1.293 2.787-3.05 2.787-5.404V6.379L12 4.308z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.941 11.765a2 2 0 10-1.882 0l-.904 3.614a.5.5 0 00.485.621h2.72a.5.5 0 00.485-.621l-.904-3.614z",
    fill: "#2E2E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovern);
export default __webpack_public_path__ + "static/media/govern.54716e851d55db2061d83c68c01fbc65.svg";
export { ForwardRef as ReactComponent };